/**
 * PanelPaciente — columna izquierda en pantalla ancha (2026-10-01).
 *
 * Arriba quién es el paciente (perfil + edad), abajo los motivos de consulta más
 * frecuentes del mostrador como botones grandes: un toque y sale la sugerencia.
 * Sin perfil elegido, los motivos quedan atenuados y el panel pide el perfil primero.
 */
import type { ProfileType } from '../types/profile'
import { ProfileChips } from './ProfileChips'
import { Icon } from './icons'

interface Props {
  profile: ProfileType | null
  onSelectProfile: (p: ProfileType) => void
  motivos: string[]
  onMotivo: (m: string) => void
  ocupado: boolean
  /** "+" junto a Paciente: otro paciente (Elvio 8-oct). Hace lo mismo que el "+" del encabezado. */
  onNuevoPaciente: () => void
}

export function PanelPaciente({ profile, onSelectProfile, motivos, onMotivo, ocupado, onNuevoPaciente }: Props) {
  const sinPerfil = profile === null
  return (
    <aside className="panel-paciente" aria-label="Paciente y motivos de consulta">
      <section className="panel-seccion">
        <div className="panel-titulo-fila panel-titulo-fila--centro">
          <h2 className="panel-titulo">Paciente</h2>
          <button
            type="button"
            className="panel-nuevo"
            aria-label="Nuevo paciente"
            title="Nuevo paciente"
            onClick={onNuevoPaciente}
          >
            <Icon.Plus />
          </button>
        </div>
        <div className="panel-perfil">
          <ProfileChips profile={profile} onSelectProfile={onSelectProfile} />
        </div>
      </section>

      <section className="panel-seccion">
        <div className="panel-titulo-fila">
          <h2 className="panel-titulo">Motivo de consulta</h2>
          <span className="panel-nota">{sinPerfil ? 'elegí el perfil primero' : 'un toque y responde'}</span>
        </div>
        <div className="motivos-grid">
          {motivos.map((m) => (
            <button
              key={m}
              type="button"
              className="motivo"
              disabled={sinPerfil || ocupado}
              aria-disabled={sinPerfil || ocupado}
              onClick={() => onMotivo(m)}
            >
              {m}
            </button>
          ))}
        </div>
      </section>
    </aside>
  )
}
